/* global document */
import $ from 'jquery';

/**
 * @param {jQuery} $el
 * @param {number} speed
 */
export default ($el, speed = 300) => new Promise((resolve) => {
  $([document.documentElement, document.body])
    .animate({
      scrollTop: $el
        .offset().top,
    }, speed).promise().then(resolve);
});
